import { restrictionZoneSchema } from './restriction-zone.schema';
import { z } from 'zod/v4';

export const restrictionZonesSchema = z.object({
  allow: z.array(restrictionZoneSchema).nullable(),
  avoid: z.array(restrictionZoneSchema).nullable(),
  warn: z.array(restrictionZoneSchema).nullable(),
});

export type RestrictionZones = z.infer<typeof restrictionZonesSchema>;
